<!-- 实时数据 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="energy-real" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.nbqxlh')">
              <el-input
                v-model="queryParams.sn"
                clearable
                :placeholder="$t('placeholder.srnbq')"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="handleQuery"
              >{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <el-table
            v-loading="loading"
            :data="tableData"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            style="width: 100%;"
            height="calc(100% - 50px)"
          >
            <template slot="empty">
              <div class="table-no-data" />
            </template>
            <el-table-column
              align="center"
              width="80px"
              type="index"
              :index="indexCount"
              :label="$t('text.xh')"
            />
            <el-table-column
              align="center"
              :label="$t('text.cjqxlh')"
              prop="gatewaysn"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.nbqxlh')"
              prop="sn"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.nbqbm')"
              prop="ialias"
              show-overflow-tooltip
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.zlsr')"
            >
              <el-table-column
                align="center"
                :label="$t('text.td')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3)" :key="item" class="row-tr">
                    <span>{{ item | pvFilter(scope.row.pvnum) }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dy')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ scope.row['upv'+ item] | nullFilter }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dianliu')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ scope.row['ipv'+ item] | nullFilter }}</span>
                  </tr>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('text.jlsc')"
            >
              <el-table-column
                align="center"
                :label="$t('text.xw')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr v-for="item in parseInt(scope.row.pvnum)" :key="item" class="row-tr">
                    <span>{{ item | lFilter }}</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dy')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr class="row-tr">
                    <span>{{ scope.row.nlua | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.nlub | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.nluc | nullFilter }}</span>
                  </tr>
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3) - 3" :key="item" class="row-tr">
                    <span>--</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.dianliu')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr class="row-tr">
                    <span>{{ scope.row.nlia | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.nlib | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.nlic | nullFilter }}</span>
                  </tr>
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3) - 3" :key="item" class="row-tr">
                    <span>--</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.gonglv')"
                class-name="row-column"
              >
                <template v-slot="scope">
                  <tr class="row-tr">
                    <span>{{ scope.row.npa | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.npb | nullFilter }}</span>
                  </tr>
                  <tr class="row-tr">
                    <span>{{ scope.row.npc | nullFilter }}</span>
                  </tr>
                  <tr v-for="item in (parseInt(scope.row.pvnum) >= 3 ? parseInt(scope.row.pvnum) : 3) - 3" :key="item" class="row-tr">
                    <span>--</span>
                  </tr>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('text.pl')"
                prop="nfrq"
                :formatter="$elFormatter"
              />
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('text.zongdl')"
              prop="fetotal"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.wendu')"
              prop="ninvtemper"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.shijian')"
              prop="sitetime"
              width="100px"
              :formatter="$elFormatter"
            />
            <el-table-column
              align="center"
              :label="$t('text.cz')"
            >
              <template v-slot="scope">
                <el-button icon="fa fa-file-text" size="small" type="text" @click="getDetail(scope.row)">{{ $t('text.xq') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            background
            layout="total, prev, pager, next"
            @current-change="getTableData"
          />
        </template>
      </el-card>
      <detailDialog :show-dialog.sync="showDialog" :prop-id="deviceId" />
    </div>
  </div>
</template>

<script>
import { QueryStationReal } from '@apis/Stations'
import detailDialog from './component/detailDialog.vue'
export default {
  components: {
    detailDialog
  },
  data () {
    return {
      queryParams: {
        stationid: this.$store.getters.station.id
      },
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      showDialog: false,
      deviceId: ''
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    // 序号
    indexCount (index) {
      return (this.pageNum - 1) * this.pageSize + (index + 1)
    },
    // 查询
    handleQuery () {
      this.pageNum = 1
      this.getTableData()
    },
    // 获取表格数据
    getTableData () {
      this.loading = true
      QueryStationReal({
        page: this.pageNum,
        perPage: this.pageSize,
        orderBy: 'sn',
        whereCondition: JSON.stringify(this.queryParams)
      })
        .then(res => {
          this.tableData = res.data.queryResults
          this.total = res.data.totalCount
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 查看详情
    getDetail (row) {
      this.showDialog = true
      this.deviceId = row.devid
    }
  }
}
</script>
<style scoped>
.energy-real {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.energy-real>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-real>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.energy-real>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.energy-real>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
.energy-real>>> .el-card__body .el-table {
  border: none;
}
.energy-real>>> .el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.energy-real>>> .el-card__body .el-table--border::after, .el-table--group::after, .el-table::before{
  background-color: transparent;
}
</style>

